const brandNameMapper: Record<string, string> = {
  sunwebnl: 'Sunweb Summer NL',
  sunwebbefr: 'Sunweb Summer BE FR',
  sunwebbenl: 'Sunweb Summer BE NL',
  sunwebde: 'Sunweb Summer DE',
  sunwebdk: 'Sunweb Summer DK',
  sunwebuk: 'Sunweb Summer UK',
  sunwebse: 'Sunweb Summer SE',
  gogonl: 'Gogo NL',
  elizanl: 'Eliza NL',
  elizabe: 'Eliza BE',
}

export function getBrandName(brand: string): string {
  return brandNameMapper[brand] || brand
}
